export default "__VITE_ASSET__B1HupM3Y__"